import React, { useState, useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import secondHeader from '../assets/images/secondHeader.png';

const Registration = () => {

    const [activeForm, setActiveForm] = useState('workshops');

    return (
        <>
            <PageHeader image={secondHeader} title="التسجيل" />

            {/* Toggle Buttons Container */}
            <div className='flex justify-center flex-wrap gap-5 my-5' >
                <button 
                    onClick={() => setActiveForm('workshops')}
                    className={`px-5 py-2 cursor-pointer ${activeForm === 'workshops' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'} rounded-md`}
                >
                    التسجيل في ورش العمل
                </button>
                <button 
                    onClick={() => setActiveForm('panels')}
                    className={`px-5 py-2 cursor-pointer ${activeForm === 'panels' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'} rounded-md`}
                >
                    التسجيل في الجلسات الحوارية
                </button>
            </div>

            {/* Iframe Container */}
            <div style={{ width: '100%', padding: '20px' }}>
                {activeForm === 'workshops' && (
                    <iframe
                        src="https://forms.ksu.edu.sa/embed/ach2mhe?lang=ar&theme=light"
                        width="100%"
                        height="1500"
                        frameBorder="0"
                        title="KSU Form - Workshops"
                        style={{ border: 'none' }}
                    ></iframe>
                )}

                {activeForm === 'panels' && (
                    <iframe
                        src="https://forms.ksu.edu.sa/embed/xfwtt42?lang=ar&theme=light"
                        width="100%"
                        height="1300"
                        frameBorder="0"
                        title="KSU Form - Panels"
                        style={{ border: 'none' }}
                    ></iframe>
                )}
            </div>
        </>
    );
};

export default Registration;